"use client";

import { useInterfere } from "@interfere/next/provider";
import { useAuth } from "@workos-inc/authkit-nextjs/components";
import { useEffect } from "react";

export function InterfereIdentity() {
  const { user } = useAuth();
  const { identity } = useInterfere();

  useEffect(() => {
    if (user) {
      identity.set({
        identifier: user.id,
        name:
          [user.firstName, user.lastName].filter(Boolean).join(" ") ||
          undefined,
        email: user.email ?? undefined,
        source: { type: "custom", name: "WorkOS" },
      });
    }
  }, [user, identity]);

  return null;
}
